<template>
    <b-modal id="demande-code" ref="demande-code"
        :no-close-on-backdrop="true"
        hide-footer
        centered>
        <template #modal-title >
                    <h4 style=" margin: 0 auto; color: #4d25bc;">BIENVENUE SUR VOTRE ESPACE</h4>


        </template>

        
              <!-- @submit.prevent="AddContratTransformer" -->
        <b-form class="p-2" v-if="form == 1">
            <div class="d-block text-justify">
                <!-- <h3 style="margin-top:30px;color: #4d25bc;">BIENVENUE SUR VOTRE ESPACE</h3> -->
            </div>

            <div>
                <b-form-group  label="Vous souhaitez ouvrir/synchroniser vos codes ?" v-slot="{ ariaDescribedby }">
                    <b-form-checkbox-group
                        :disabled="checkboxEnbled"
                        id="checkbox-group-1"
                        v-model="selected"
                        :options="list_assureurs"
                        :aria-describedby="ariaDescribedby"
                        stacked
                        name="flavour-1"
                    ></b-form-checkbox-group>
                </b-form-group>
            </div>

            <div>
                <b-form-checkbox
                    id="checkbox-1"
                    v-model="plustard"
                    name="checkbox-1"
                    value="accepted"
                    unchecked-value="not_accepted">
                    Plus tard
                </b-form-checkbox>
            </div>
            
            <div class="d-flex justify-content-end">
                <b-button v-if="plustard == 'accepted'"
                    variant="primary"
                    size="sm"
                    class="mt-1"
                    @click="closeModelPlustard">
                          
                    <span class="align-middle text-capitalize">Fermer la fenêtre</span>
                </b-button>

                <b-button v-if="selected.length != 0 && currentUser.courtier_user[0].isPrincipal && codeassureur == 0 "
                    variant="primary"
                    size="sm"
                    class="mt-1"
                    @click="goToFicherDemandeCode">
                          
                    <span class="align-middle text-capitalize">J’ouvre/<span class="text-lowercase">synchronise</span>  mes codes</span>
                </b-button>

                <b-button v-if="selected.length != 0 && !currentUser.courtier_user[0].isPrincipal"
                    variant="primary"
                    size="sm"
                    class="mt-1"
                    @click="goToFicherDemandeCode">
                          
                    <span class="align-middle text-capitalize">J’ouvre/synchronise mes codes”</span>
                </b-button>

                <b-button v-if="selected.length != 0 && currentUser.courtier_user[0].isPrincipal && codeassureur > 0 "
                        variant="primary"
                        size="sm"
                        class="mt-1"
                        @click="suivant">
                          
                        <span class="align-middle text-capitalize">Suivant</span>
                </b-button>

            </div>
             

        </b-form>

        <b-form class="p-2" v-if="form == 2">
                <div class="d-block text-justify">
                    <p>Vous avez déjà fait une demande de code. Merci de vérifier et valider vos informations.</p>
                </div>

              
            
                <div class="d-flex justify-content-end">
                    <b-button 
                        variant="primary"
                        size="sm"
                        class="mt-1"
                        @click="goToFicherDemandeCode">
                          
                        <span class="align-middle text-capitalize">Je vérifie et valide mes informations</span>
                    </b-button>

                </div>
             

            </b-form>
    </b-modal>
</template>

<script>
import {
    BModal,
    BForm,
    BFormCheckbox,
    BFormCheckboxGroup,
    BFormGroup,
    BButton
} from 'bootstrap-vue'

export default {
    components: {
        BModal,
        BForm,
        BFormCheckbox,
        BFormCheckboxGroup,
        BFormGroup,
        BButton

    },
    data() {
        return {
            currentUser: JSON.parse(localStorage.getItem('userData')),
            selected: [],
            list_assureurs: [],
            showPopup: null,
            checkboxEnbled:false,
            plustard: 'not_accepted',
            codeassureur: 0,
            form : 1,
        }
    },
    mounted() {
        this.getDemandeCode()
    },
    watch: {
        plustard() {
            if (this.plustard == 'accepted') {
                this.checkboxEnbled = true
            }
            else {
                this.checkboxEnbled = false
            }
            this.selected = []
        }
        
    },
    methods: {
        getDemandeCode() {
             this.$http.get(`/portefeuilles/demandeCodeAssureur/${this.currentUser.courtier_user[0].courtier_id}`)
                 .then(res => {
                    this.showPopup = res.data.data.showPopup
                    res.data.data.assureurs.forEach(el => {
                        this.list_assureurs.push({
                            value: el.id,
                            text: el.nom_com_assureur
                        })
                    })
                    this.codeassureur = res.data.data.countcode
                    
                    if (this.showPopup == true) {
                        this.form = 1
                        this.$refs['demande-code'].show()

                    }
 
                })
                .catch(err => {
                    console.log(err)
                })
        },
        closeModelPlustard() {
            this.$http
                .post('/portefeuilles/plusTardDemandeCode',{ courtier_id: this.currentUser.courtier_user[0].courtier_id })
                .then(res => {
                if (res.data.success) {
                    this.$refs['demande-code'].hide()
                }
            })
            .catch(err => {
                console.error(err)
            })
        },
        goToFicherDemandeCode() {
            if (this.currentUser.courtier_user[0].isPrincipal) {
                let assureurs = this.list_assureurs.filter(item => this.selected.includes(item.value))
                assureurs = assureurs.map(item => ({
                    id: item.value,
                    nom_assureur: item.text
                }))
                this.$http
                    .post('/portefeuilles/trackingPopupDemandeCode', {
                        data: {
                            'assureurs': assureurs,
                            'plustard': this.plustard
                        },
                        courtier_id : this.currentUser.courtier_user[0].courtier_id
                     })
                    .then(res => {
                        if (res.data.success) {
                            console.log(res.data.data)
                            this.$router.push({
                                name: 'fiche-demande-ouverture-code',
                                 params: {
                                    'popup_demandecode_id': res.data.data,
                                }
                            })
                            this.$refs['demande-code'].hide()
                        }
                    })
                    .catch(err => {
                        console.error(err)
                })  
            }
            else {
                console.log(this.currentUser.courtier_user[0].courtier.courtier_user[0].user.personne_physique.nom)
                this.$swal({
                    html: "<div style='text-align: justify;'>Pour faire une demande de code, merci de vous rapprocher de votre administrateur de cabinet : "+ this.currentUser.courtier_user[0].courtier.courtier_user[0].user.personne_physique.prenom + " " + this.currentUser.courtier_user[0].courtier.courtier_user[0].user.personne_physique.nom +"</div>",
                    icon: 'info',
                    confirmButtonText: "Ok",
                    customClass: {
                    confirmButton: "btn btn-primary",
                    },

                    buttonsStyling: false,
                })
                this.$refs['demande-code'].hide()

            }
        }
        ,
        suivant() {
            this.form = 2
        }
      
    },
  
}
</script>

<style>

</style>
